import React from 'react';

interface NewDevice {
    name: string;
    type: string;
    status: 'online' | 'offline' | 'error';
    ip_address: string;
    port: string;
}

interface Props {
    newDevice: NewDevice;
    onChange: (d: NewDevice) => void;
    onSubmit: (e: React.FormEvent) => void;
}

const ManualTab: React.FC<Props> = ({ newDevice, onChange, onSubmit }) => (
    <div style={{
        backgroundColor: '#f8f9fa',
        padding: '20px',
        borderRadius: '4px',
        marginTop: '16px',
        marginBottom: '20px',
        border: '1px solid #ddd'
    }}>
        <h3>Lägg till enhet manuellt</h3>
        <p style={{ color: '#666', fontSize: '14px', marginBottom: '10px' }}>
            💡 <strong>Tips:</strong> Använd fliken ”Parkoppla” för att hitta och parkoppla Zigbee-enheter automatiskt.<br/>
            Det här formuläret är till för enheter som redan är anslutna.
        </p>
        <form onSubmit={onSubmit}>
            <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                    Enhetens namn:
                </label>
                <input
                    type="text"
                    value={newDevice.name}
                    onChange={(e) => onChange({ ...newDevice, name: e.target.value })}
                    required
                    placeholder="t.ex. Lampa vardagsrum"
                    style={{
                        width: '100%',
                        padding: '8px',
                        fontSize: '14px',
                        border: '1px solid #ddd',
                        borderRadius: '4px'
                    }}
                />
            </div>
            <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                    Typ av enhet:
                </label>
                <select
                    value={newDevice.type}
                    onChange={(e) => onChange({ ...newDevice, type: e.target.value })}
                    style={{
                        width: '100%',
                        padding: '8px',
                        fontSize: '14px',
                        border: '1px solid #ddd',
                        borderRadius: '4px'
                    }}
                >
                    <option value="light">Lampa</option>
                    <option value="switch">Strömbrytare/uttag</option>
                    <option value="temperature">Temperaturgivare</option>
                    <option value="humidity">Fuktgivare</option>
                    <option value="motion">Rörelsevakt</option>
                    <option value="contact">Dörr-/fönstergivare</option>
                    <option value="dimmer">Dimmer</option>
                    <option value="thermostat">Termostat</option>
                    <option value="power_meter">Elmätare</option>
                    <option value="router">Router</option>
                </select>
            </div>

            {newDevice.type === 'router' && (
                <>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                            IP-adress: <span style={{ color: '#dc3545' }}>*</span>
                        </label>
                        <input
                            type="text"
                            value={newDevice.ip_address}
                            onChange={(e) => onChange({ ...newDevice, ip_address: e.target.value })}
                            required
                            placeholder="t.ex. 192.168.1.1"
                            style={{
                                width: '100%',
                                padding: '8px',
                                fontSize: '14px',
                                border: '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                            Port:
                        </label>
                        <input
                            type="number"
                            value={newDevice.port}
                            onChange={(e) => onChange({ ...newDevice, port: e.target.value })}
                            placeholder="t.ex. 8080"
                            min="1"
                            max="65535"
                            style={{
                                width: '100%',
                                padding: '8px',
                                fontSize: '14px',
                                border: '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                </>
            )}
            <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                    Läge från början:
                </label>
                <select
                    value={newDevice.status}
                    onChange={(e) => onChange({ ...newDevice, status: e.target.value as 'online' | 'offline' | 'error' })}
                    style={{
                        width: '100%',
                        padding: '8px',
                        fontSize: '14px',
                        border: '1px solid #ddd',
                        borderRadius: '4px'
                    }}
                >
                    <option value="online">Uppkopplad</option>
                    <option value="offline">Frånkopplad</option>
                    <option value="error">Fel</option>
                </select>
            </div>
            <button
                type="submit"
                style={{
                    padding: '10px 20px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '16px'
                }}
            >
                Lägg till enhet
            </button>
        </form>
    </div>
);

export default ManualTab;
